import { DataBean } from "../DataBean";

export class Addguideproduct extends DataBean {

    public async addTransportGuideProduct(idTransportGuide: any, transportGuideDate: any, product: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.TransportGuideProduct_addTransportGuideProduct_Number_java.util.Date_inventory.Product", [idTransportGuide, transportGuideDate, product]);
    }

}